(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text-block"] && !Shopify.designMode) return;
  try {
    // <text-underline> custom HTML Element
  class TextUnderline extends HTMLElement {constructor() {super()}}
  customElements.define('text-underline', TextUnderline);

  // <text-accent> custom HTML Element
  class TextAccent extends HTMLElement {constructor() {super()}}
  customElements.define('text-accent', TextAccent);
  
  // <text-tag> custom HTML Element
  class TextTag extends HTMLElement {constructor() {super()}}
  customElements.define('text-tag', TextTag);

  // <timer-component> custom HTML Element
  class TimerComponent extends HTMLElement {
    static get observedAttributes() {
      return ['data-seconds'];
    }

    constructor() {
      super();
      this.remainingSeconds = 0;
      this.interval = null;
    }

    connectedCallback() {
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-seconds' && oldValue !== newValue) {
        this.start();
      }
    }

    start() {
      this.stop();

      const value = this.dataset.seconds;

      if (value === 'midnight') {
        this.remainingSeconds = this.secondsUntilMidnight();
      } else {
        this.remainingSeconds = parseInt(value, 10);
      }

      if (isNaN(this.remainingSeconds) || this.remainingSeconds < 0) return;

      this.render();

      this.interval = setInterval(() => {
        this.remainingSeconds--;

        if (this.remainingSeconds < 0) {
          this.stop();
          return;
        }

        this.render();
      }, 1000);
    }

    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    secondsUntilMidnight() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);

      console.log(midnight);

      return Math.floor((midnight - now) / 1000);
    }

    render() {
      const h = Math.floor(this.remainingSeconds / 3600);
      const m = Math.floor((this.remainingSeconds % 3600) / 60);
      const s = this.remainingSeconds % 60;

      this.innerHTML =
        `${String(h).padStart(2, '0')}:` +
        `${String(m).padStart(2, '0')}:` +
        `${String(s).padStart(2, '0')}`;
    }
  }

  customElements.define('timer-component', TimerComponent);
  } catch(e) { console.error(e); }
})();

})();
